import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9dc65954"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "labeled-text" }
const _hoisted_3 = { class: "group-number" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-file" }, null, -1))
const _hoisted_5 = { class: "details-btn-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsTextWithLabel = _resolveComponent("AsTextWithLabel")!
  const _component_AsBlock = _resolveComponent("AsBlock")!

  return (_openBlock(), _createBlock(_component_AsBlock, { "hover-effect": true }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "group-board-item",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.navigateToDetails && _ctx.navigateToDetails(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('name')), 1),
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", null, _toDisplayString(_ctx.model.name), 1)
            ])
          ]),
          _createVNode(_component_AsTextWithLabel, {
            label: _ctx.$t('group.previousMeeting'),
            value: _ctx.formatStringDate(_ctx.model.previousMeetingDate) || '---'
          }, null, 8, ["label", "value"]),
          _createVNode(_component_AsTextWithLabel, {
            label: _ctx.$t('group.nextMeeting'),
            value: _ctx.formatStringDate(_ctx.model.nextMeetingDate) || '---'
          }, null, 8, ["label", "value"]),
          _createVNode(_component_AsTextWithLabel, {
            label: _ctx.$t('group.membersCount'),
            value: _ctx.getCountLabel(_ctx.model.membersCount, _ctx.$t('member'), _ctx.$t('members'))
          }, null, 8, ["label", "value"]),
          _createVNode(_component_AsTextWithLabel, {
            label: _ctx.$t('group.meetingsCount'),
            value: _ctx.getCountLabel(_ctx.model.meetingsCount, _ctx.$t('meeting'), _ctx.$t('meetings'))
          }, null, 8, ["label", "value"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigateToDetails && _ctx.navigateToDetails(...args))),
              class: "details-btn"
            }, _toDisplayString(_ctx.$t('details')), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}